import { render, staticRenderFns } from "./VaultCreateCategoryModal.vue?vue&type=template&id=3c4e88c8&"
import script from "./VaultCreateCategoryModal.vue?vue&type=script&lang=ts&"
export * from "./VaultCreateCategoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports